const base_url = "";
export const hostresgister = `${base_url}/user/register`;
export const userRegister = `${base_url}/user/register`;
export const VerifyOtp = `${base_url}/user/verify-otp`;
export const ResendOtp = `${base_url}/user/resend-otp`;
export const GetZone = `${base_url}/property/get-zones`;
export const GetCities = `${base_url}/property/get-cities`;
export const postProperty = `${base_url}/property/add-property`;
export const myProperties = `${base_url}/property/my-properties`;
export const enableDisableProperty = `${base_url}/property/disableEnableProperty`;
export const dashboard = `${base_url}/user/dashboard`;
export const updateProfile = `${base_url}/user/update-profile`;
export const userDetail = `${base_url}/user/get-user-detail`;
export const updatepasword = `${base_url}/user/update-password`;
export const getPropertiesDiscount = `${base_url}/property/discounts`;
export const addDiscount = `${base_url}/property/add-discount`;
export const getBlockedDates = `${base_url}/property/block-dates`;
export const blockDate = `${base_url}/property/add-block-date`;
export const forgotpassword = `${base_url}/user/send-reset-password-otp`;
export const verifyForgotPassword = `${base_url}/user/reset-password`;
export const login = `${base_url}/user/login`;
export const addWishlist = `${base_url}/property/wishlist/add`;
export const UserWishlist = `${base_url}/property/wishlist`;
export const checkAvailabilyAndGetPrice = `${base_url}/property/check-availabilty-price`;
export const reserveProperty = `${base_url}/property/book-property`;
export const myBookings = `${base_url}/property/user/bookings`;
export const hostBookings = `${base_url}/property/host/bookings`;
export const cancelBooking = `${base_url}/property/cancel-booking`;
export const acceptRejectBooking = `${base_url}/property/accept-reject`;
export const addReviewForProperty = `${base_url}/property/add-review`;
export const PropertyReviews = `${base_url}/property/reviews`;
export const addProfilePicture = `${base_url}/user/upload-profile-picture`;
export const Myreferrals = `${base_url}/user/my-referrals`;
export const googleLogin = `${base_url}/user/google-login`;
export const addPropertyView = `${base_url}/property/addPropertyView`;
export const dashboardStats = `${base_url}/user/property-dashboard`;
export const dashboardChat = `${base_url}/user/property-dashboard-chart`;
export const dashboardChatView = `${base_url}/user/property-dashboard-viewchart`;
export const propertyTypes = `${base_url}/property/property-types`;
export const facilitiesTypes = `${base_url}/property/facilities-types`;
export const propertyTypesHome = `${base_url}/property/home-property-types`;

export const report = `${base_url}/property/report`;

